import { useTheme } from '@mui/material'
import { isPositionEvent } from '@tunasong/schemas'
import type { RendererPlugin } from '../renderer.js'

const Notch: RendererPlugin = ({ laneHeight, event, pixelsPerSecond }) => {
  const theme = useTheme()

  if (!isPositionEvent(event)) {
    return null
  }
  const x = event.start * pixelsPerSecond
  const y = laneHeight * 2

  return <rect x={x} y={y} width={1} height={laneHeight} fill={theme.vars.palette.text.primary} />
}

export default Notch
